import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TenantService } from '../../../Services/tenant.service';
import { PermissionService } from '../../../Services/permission.service';
import { Permissions } from '../../../Models/Permissions';
import { ProvisionedApplicationsTypes } from '@app/Enums';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'my-package',
    templateUrl: './airsweb.component.html',
    styleUrls: ['./airsweb.component.css', '../../../layout.css'],
    imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListItem, RouterLink, RouterLinkActive, MatIcon, RouterOutlet]
})
export class AirswebComponent implements OnInit {
  provisioned: boolean;

  readonly permissions = Permissions;

  constructor(
    private router: Router,
    private tenantService: TenantService,
    public permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    if (
      !(
        this.tenantService.selectedTenant.ProvisionedApplications &&
        this.tenantService.selectedTenant.ProvisionedApplications.find(
          (app) => app === ProvisionedApplicationsTypes.Airsweb
        )
      )
    ) {
      this.router.navigate([
        '/tenant',
        this.tenantService.selectedTenant.TenantId,
        'airsweb',
        'new',
      ]);
    } else {
      this.provisioned = true;
    }
  }

  hasClonePermission(): boolean {
      return this.permissionService.hasPermission(Permissions.cloneTenant);
  }

  showDelete(): boolean {
    return this.userHasDeletePermission();
  }

  isTenantLive(): boolean {
    return this.tenantService.tenantStatus.value === 'LIVE';
  }

  private userHasDeletePermission(): boolean {
    return this.permissionService.hasPermission(this.permissions.deleteTenant);
  }
}
